import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('contentful'),
  hasConnectionStatus: false,
  defaultAuthenticationType: 'bearer',
  avatarPath: avatars.contentful,
  logoPath: logos.contentful
});
